export default {_name:'checkbox',module:'Field',view:'Element/Field/Check',options:{xs:'auto'},mobileOptions:{ms:'auto'}}